import { NgModule }                          from '@angular/core';
import { UIRouterUpgradeModule }             from '@uirouter/angular-hybrid';

import { HaynesProAddLaborTimesComponent }                        from './haynes-pro.add-labor-times.component';
import { HaynesProDiagnosticToolAdjustmentsComponent }            from './diagnostic-tool/haynes-pro.diagnostic-tool.adjustments.component';
import { HaynesProDiagnosticToolComponent }                       from './diagnostic-tool/haynes-pro.diagnostic-tool.component';
import { HaynesProDiagnosticToolDiagnosticDetailsComponent }      from './diagnostic-tool/haynes-pro.diagnostic-tool.diagnostic-details.component';
import { HaynesProDiagnosticToolLocationsComponent }              from './diagnostic-tool/haynes-pro.diagnostic-tool.locations.component';
import { HaynesProDiagnosticToolLubricantsComponent }             from './diagnostic-tool/haynes-pro.diagnostic-tool.lubricants.component';
import { HaynesProDiagnosticToolRepairDetailsComponent }          from './diagnostic-tool/haynes-pro.diagnostic-tool.repair-details.component';
import { HaynesProDiagnosticToolRepairManualsComponent }          from './diagnostic-tool/haynes-pro.diagnostic-tool.repair-manuals.component';
import { HaynesProDiagnosticToolSectionComponent }                from './diagnostic-tool/haynes-pro.diagnostic-tool.section.component';
import { HaynesProDiagnosticToolSmartPackComponent }              from './diagnostic-tool/haynes-pro.diagnostic-tool.smart-pack.component';
import { HaynesProDiagnosticToolSmartpackDetailsComponent }       from './diagnostic-tool/haynes-pro.diagnostic-tool.smart-pack-details.component';
import { HaynesProDiagnosticToolTechnicalDrawingsComponent }      from './diagnostic-tool/haynes-pro.diagnostic-tool.technical-drawings.component';
import { HaynesProDiagnosticToolWarningLightsComponent }          from './diagnostic-tool/haynes-pro.diagnostic-tool.warning-lights.component';
import { HaynesProLaborTimesComponent }                           from './haynes-pro.labor-times.component';
import { HaynesProLookupSettingsComponent }                       from './haynes-pro.lookup.settings.component';
import { HaynesProMaintenanceTimesComponent }                     from './haynes-pro.maintenance-times.component';
import { HaynesProMaintenanceTimesExpandedRowComponent }          from './haynes-pro.maintenance-times.row.expanded.component';
import { HaynesProMaintenanceTimesExtraDataExpandedRowComponent } from './haynes-pro.maintenance-times.extra-data.row.expanded.component';
import { HaynesProPurchaseLookupsComponent }                      from './haynes-pro.purchase-lookups.component';
import { HaynesProRepairTimesComponent }                          from './haynes-pro.repair-times.component';
import { HaynesProService }                                       from './haynes-pro.service';
import { HaynesProSettingsComponent }                             from './haynes-pro.settings.component';
import { HaynesProStates }                                        from './haynes-pro.states';
import { HaynesProTechnicalDrawingsViewerComponent }              from './diagnostic-tool/haynes-pro.technical-drawings-viewer.component';
import { HaynesProSubscriptionSettingsComponent }                 from './haynes-pro.subscription.settings.component';
import { HaynesProVehicleSelectionComponent }                     from './haynes-pro.vehicle-selection.component';
import { SharedModule }                                           from '../shared/shared.module';
import { TableModule }                                            from '../table/table.module';

@NgModule({
  declarations: [
    HaynesProAddLaborTimesComponent,
    HaynesProLaborTimesComponent,
    HaynesProLookupSettingsComponent,
    HaynesProMaintenanceTimesComponent,
    HaynesProPurchaseLookupsComponent,
    HaynesProRepairTimesComponent,
    HaynesProSettingsComponent,
    HaynesProSubscriptionSettingsComponent,
    HaynesProVehicleSelectionComponent,
    HaynesProDiagnosticToolAdjustmentsComponent,
    HaynesProDiagnosticToolComponent,
    HaynesProDiagnosticToolDiagnosticDetailsComponent,
    HaynesProDiagnosticToolLubricantsComponent,
    HaynesProDiagnosticToolLocationsComponent,
    HaynesProDiagnosticToolRepairManualsComponent,
    HaynesProDiagnosticToolRepairDetailsComponent,
    HaynesProDiagnosticToolSectionComponent,
    HaynesProDiagnosticToolSmartPackComponent,
    HaynesProDiagnosticToolSmartpackDetailsComponent,
    HaynesProDiagnosticToolTechnicalDrawingsComponent,
    HaynesProDiagnosticToolWarningLightsComponent,
    HaynesProMaintenanceTimesExpandedRowComponent,
    HaynesProMaintenanceTimesExtraDataExpandedRowComponent,
    HaynesProTechnicalDrawingsViewerComponent
  ],
  entryComponents: [
    HaynesProAddLaborTimesComponent,
    HaynesProLaborTimesComponent,
    HaynesProLookupSettingsComponent,
    HaynesProMaintenanceTimesComponent,
    HaynesProPurchaseLookupsComponent,
    HaynesProRepairTimesComponent,
    HaynesProSettingsComponent,
    HaynesProSubscriptionSettingsComponent,
    HaynesProVehicleSelectionComponent,
    HaynesProDiagnosticToolAdjustmentsComponent,
    HaynesProDiagnosticToolComponent,
    HaynesProDiagnosticToolDiagnosticDetailsComponent,
    HaynesProDiagnosticToolLubricantsComponent,
    HaynesProDiagnosticToolLocationsComponent,
    HaynesProDiagnosticToolRepairManualsComponent,
    HaynesProDiagnosticToolRepairDetailsComponent,
    HaynesProDiagnosticToolSectionComponent,
    HaynesProDiagnosticToolSmartPackComponent,
    HaynesProDiagnosticToolSmartpackDetailsComponent,
    HaynesProDiagnosticToolTechnicalDrawingsComponent,
    HaynesProDiagnosticToolWarningLightsComponent,
    HaynesProMaintenanceTimesExpandedRowComponent,
    HaynesProMaintenanceTimesExtraDataExpandedRowComponent,
    HaynesProTechnicalDrawingsViewerComponent
  ],
  imports: [
    SharedModule,
    TableModule,
    UIRouterUpgradeModule.forChild({ states: HaynesProStates })
  ],
  providers: [
    HaynesProService
  ]
})
export class HaynesProModule {}
